import { useEffect } from "react";
import Layout from "@/components/Layout";
import { CreditCard } from "lucide-react";
import { useTranslations } from "@/lib/translations";
import SubscriptionCards from "@/components/SubscriptionCards";
import { usePageMeta } from "@/hooks/use-page-meta";
import { useJsonLd } from "@/hooks/use-json-ld";
import { buildBreadcrumbList } from "@/lib/breadcrumbs";

const Subscriptions = () => {
  const { t } = useTranslations();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  usePageMeta({
    title: "ESG Ratings Subscriptions for Investors | ESG Invest",
    description:
      "Choose a Middle East ESG ratings subscription. Trial access, professional plans by AUM & market, or individual company reports for $100. Built for institutional investors.",
    path: "/subscriptions",
  });

  useJsonLd(
    "ld-subscriptions-breadcrumbs",
    buildBreadcrumbList([
      { name: "Home", path: "/" },
      { name: "Subscriptions", path: "/subscriptions" },
    ]),
  );

  return (
    <Layout>
      <section className="relative text-white py-20 overflow-hidden" style={{ backgroundImage: 'url(/subscriptions-hero-bg.webp)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-black/60 pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-sm font-medium mb-6">
            <CreditCard className="h-4 w-4 text-accent" />
            {t('sub.badge')}
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6" data-testid="text-subscriptions-title">
            {t("sub.title")}
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto mb-4" data-testid="text-subscriptions-subtitle">
            {t("sub.subtitle")}
          </p>
        </div>
      </section>

      <div className="bg-se-gray-50 dark:bg-background py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <SubscriptionCards />
        </div>
      </div>
    </Layout>
  );
};

export default Subscriptions;
